import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import './dashboard.css';

function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return String(iso);
  }
}

export default function Businesses() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setError('');
      setLoading(true);
      try {
        const { data, error: qErr } = await supabase
          .from('businesses')
          .select('id, name, owner_email, twilio_number, created_at, is_active')
          .order('created_at', { ascending: false });

        if (qErr) throw qErr;
        if (!cancelled) setRows(data ?? []);
      } catch (e) {
        if (!cancelled) setError(e?.message ?? 'Failed to load businesses.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <h1 className="page-title">Businesses</h1>
      {error ? <p className="page-error">{error}</p> : null}
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Business name</th>
              <th>Owner email</th>
              <th>Twilio number</th>
              <th>Created at</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="table-muted">
                  Loading…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={5} className="table-muted">
                  No businesses found.
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr
                  key={row.id}
                  className="data-table-row-clickable"
                  onClick={() => navigate(`/businesses/${row.id}`)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigate(`/businesses/${row.id}`);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <td>{row.name ?? '—'}</td>
                  <td>{row.owner_email ?? '—'}</td>
                  <td>{row.twilio_number ?? '—'}</td>
                  <td>{formatDate(row.created_at)}</td>
                  <td>{row.is_active ? 'Yes' : 'No'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
